import { Box, Grid } from "@mui/material";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import ProfileCard from "components/profileCard/ProfileCard";
import DetailsCard from "components/profileCard/detailsCard.js/DetailsCard";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import VehicleTabList from "./VehicleTabList";
import { useDispatch, useSelector } from "react-redux";
import { getMatrixVehicle, getMoreVehicle, getVehicle } from "redux/actions/UserVehicle";

import { vehicleInfo as generateVehicleInfo, vehicleDialogData } from 'pages/vehicle/VehiceData';
import { amenitiesVehicle as aminitiesVehicleInfo } from 'pages/vehicle/VehiceData';
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { handlePermissions } from "utils/utils";

const VehicleDetails = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const [breadcrumb, setBreadCrumb] = useState(null);
  const { state } = location;

  const vehicleData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);

  const breadcrumbPaths = [
    { name: "Vehicle", url: "/vehicle", className: "colorGrey" },
    { name: state?.name, url: "/vehicle/details", className: "colorPrimary" },
  ];

  const subVendorBreadcrumbPaths = [
    { name: "Sub-vendor", url: "", className: "colorGrey" },
    { name: state?.companyName, url: "", id: state?.subVendorId, companyId: state?.comapnyId, className: "colorGrey" },
    { name: "Vehicle", url: "", className: "colorGrey" },
    { name: state?.name, url: "", className: "colorPrimary" },
  ]

  const filterData =  {
    vehicleId: state?.id,
    status:"",
    page:"",
    pageSize:"",
    date:"",
    duration:""
  }

  const vehicleComplianceData = {
    submitterId: state?.id,
    submitterType:"vehicle"
  }

  const vehicleMatrix = {
    vehicleId:state?.id,
  }

  useEffect(() => {

    if(Number(location.pathname.split("/")?.length) === Number(3)) {
      setBreadCrumb(breadcrumbPaths);
    }
    else {
      setBreadCrumb(subVendorBreadcrumbPaths);
    }

    dispatch(getVehicle(filterData));
    dispatch(getMoreVehicle(vehicleComplianceData));
      dispatch(getMatrixVehicle(vehicleMatrix));
  }, []);

  const vehicleInfotable = generateVehicleInfo(vehicleData); 
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleData);

  const profileObj = {
    details: vehicleData, 
  }

  const vehcileDetails = {
    vehicleData: vehicleData,
    vehicleInfotable: vehicleInfotable,
    vehicleInfoaminities: vehicleInfoaminities,
    vehicleMoreData: vehicleMoreData,
    vehicleMatrixData: vehicleMatrixData
  }

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const subVendorRoleEnum = roleAndPermissionEnum.subvendor
  const cityManagerRoleEnum = roleAndPermissionEnum.citymanager
  const driverRoleEnum = roleAndPermissionEnum.driver
  const vehicleRoleEnum = roleAndPermissionEnum.vehicle

  const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

  const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});

  const accessForDriverAll = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});

  const editDriverAccess = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.edit});

  const editVehicleAccess = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.edit});

  const editButton = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll|| editDriverAccess || editVehicleAccess)

  return (
    <Box>
      <CommonBreadCrumb paths={breadcrumb} />
      <ProfileCard profileObj={profileObj} page={"vehicle"} />
      <VehicleTabList {...vehcileDetails} editButton={editButton} />
    </Box>
  );
};

export default VehicleDetails;
